import React, {Component} from 'react';
import Styles from './style.css';
import HeaderSignupOne from "../../components/header-signup-one/component";
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {cartRegister} from "../../services/cartRegister";
import {dataRegister} from "../../services/dataRegister";
import {langRegister} from "../../services/langRegister";
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import ErrorHandler from "../../components/error-handler/component";
import {imagesRegister} from "../../services/imagesRegister";
import {quotesRegister} from "../../services/quotesRegister";
import Information from "../../components/information/component";
import BoosterHeader from "../../components/booster-header/component";
import {scraperRegister} from "../../services/scraperRegister";
import {tokenRegister} from "../../services/tokenRegister";
import {userRegister} from "../../services/userRegister";

class BoosterOptions extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            error: false,
            selected: "instant",
            disabled: ""
        };
    };

    componentWillMount() {
        window.scrollTo(0, 0);

        this._updateUser();

        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactGA.pageview('/booster/options');
            ReactGA4.send({ hitType: "pageview", page: "/booster/options" });
            ReactGA.event({category: 'User', action: 'Initiated Checkout', label: 'Options'});
            ReactGA4.event({category: 'User', action: 'Initiated Checkout', label: 'Options'});
        }

        //FACEBOOK PIXEL
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactPixel.pageView();
            ReactPixel.track('InitiateCheckout');
        }

        this._updateSelected();
    }

    componentDidMount() {
        let token = tokenRegister.getToken();
        if(!token){
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang());
        }
    }

    _updateUser(){
        try {
            let user = userRegister.get();
            if (user) {
                this.setState({
                    agents: Array.isArray(user.agents)?(user.agents.length>0):false
                });
            }
        } catch (error) {}
    }

    _updateSelected() {
        let cart = cartRegister.get();
        let disabled = salesChannelRegister.get('goal_off');

        if(disabled === "1"){
            this.setState({
                disabled: "1",
                isLoading: false,
                selected: "instant"
            })
        }else if(disabled === "2"){
            this.setState({
                disabled: "2",
                isLoading: false,
                selected: "continues"
            })
        }else{
            this.setState({
                isLoading: false,
                selected: cart.crossroad?cart.crossroad:"instant"
            });
        }
    }

    _next(value) {
        console.log(value);
        cartRegister.setOptions(value);
        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/industry")
    }

    _renderText(item) {
        return langRegister.get("signup-crossroad", item);
    }

    renders = {
        text: (item) => {
            return langRegister.get("booster-crossroad", item);
        }
    };

    render() {
        return (
            <div>
                <BoosterHeader props={this.props}/>
                {
                    !this.state.isLoading && !this.state.error &&
                    <div className={Styles.container}>
                        <div style={{color: 'var(--black-base-color)'}} className={Styles.title}>
                            <div>
                                {this._renderText("item_1")}
                            </div>
                        </div>
                        <div className={Styles.optionsContainer}>
                            <div className={Styles.optionsContainerItem}>
                                <div className={Styles.optionsContainerItemInner}>
                                    <div onClick={() => {
                                        if(this.state.disabled !== "1"){
                                            this._next("continues")
                                        }
                                    }} className={
                                        cx(Styles.optionsContainerItemInnerLayer,
                                            {
                                                [Styles.optionsContainerItemInnerLayerSelected]: this.state.selected === "continues",
                                            })
                                    }>
                                        <div style={this.state.disabled === "1"?(salesChannelRegister.get('name')==='yieldlock'?{color: '#bfbfbf'}:{color: "#bfbfbf"}):{}} className={Styles.optionsContainerItemInnerTitle}>
                                            {this._renderText("item_8")}<br/>{this._renderText("item_9")}
                                        </div>
                                        <div style={this.state.disabled === "1"?(salesChannelRegister.get('name')==='yieldlock'?{color: '#bfbfbf'}:{color: "#bfbfbf"}):(salesChannelRegister.get('name')==='yieldlock'?{}:{})} className={Styles.optionsContainerItemInnerSubtitle}>
                                            {this._renderText("item_10")}
                                        </div>
                                    </div>
                                </div>
                                <div className={Styles.optionsContainerItemUnderTitle}>
                                    <div className={Styles.optionsContainerItemUnderTitleDollar}>
                                        $
                                    </div>
                                    <div className={Styles.optionsContainerItemUnderTitleText}>
                                        {this._renderText("item_11")}
                                    </div>
                                </div>
                            </div>
                            <div className={Styles.optionsContainerItem}>
                                <div className={Styles.optionsContainerItemInner}>
                                    <div onClick={() => {
                                        if(this.state.disabled !== "2"){
                                            this._next("instant")
                                        }
                                    }} className={
                                        cx(Styles.optionsContainerItemInnerLayer,
                                            {
                                                [Styles.optionsContainerItemInnerLayerSelected]: this.state.selected === "instant",
                                            })
                                    }>
                                        <div style={this.state.disabled === "2"?(salesChannelRegister.get('name')==='yieldlock'?{color: '#bfbfbf'}:{color: "#bfbfbf"}):{}} className={Styles.optionsContainerItemInnerTitle}>
                                            {this._renderText("item_12")}<br/>{this._renderText("item_13")}
                                        </div>
                                        <div style={this.state.disabled === "2"?(salesChannelRegister.get('name')==='yieldlock'?{color: '#bfbfbf'}:{color: "#bfbfbf"}):(salesChannelRegister.get('name')==='yieldlock'?{}:{})} className={Styles.optionsContainerItemInnerSubtitle}>
                                            {this._renderText("item_14")}
                                        </div>
                                    </div>
                                    <div style={this.state.disabled === "2"?(salesChannelRegister.get('name')==='yieldlock'?{backgroundColor: '#bfbfbf'}:{backgroundColor: "#bfbfbf"}):(salesChannelRegister.get('name')==='yieldlock'?{backgroundColor: '#E65032'}:{})} className={Styles.optionsContainerItemInnerBadge}>
                                        {this._renderText("item_15")}
                                    </div>
                                </div>
                                <div className={Styles.optionsContainerItemUnderTitle}>
                                    <div className={Styles.optionsContainerItemUnderTitleDollar}>
                                        $$$
                                    </div>
                                    <div className={Styles.optionsContainerItemUnderTitleText}>
                                        {this._renderText("item_16")}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            this.state.agents &&
                            <div>
                                <div
                                    onClick={() => {
                                        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/agents")
                                    }}
                                    style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                    className={
                                        cx(Styles.backButton,
                                            {
                                                [Styles.backButtonCenter]: false,
                                            })
                                    }>
                                    {this._renderText("item_4")}
                                </div>
                            </div>
                        }
                    </div>
                }
                {
                    this.state.isLoading &&
                    <div className={Styles.loader}>
                        <BeatLoader size={30} color={'var(--first-color)'} loading={true}/>
                    </div>
                }
                {
                    !this.state.isLoading && this.state.error &&
                    <div className={Styles.loader}>
                        <ErrorHandler props={this.props}/>
                    </div>
                }
                <div id={"bottom"} style={{width: "100%"}}/>
            </div>
        );
    }
}

export default BoosterOptions;


// WEBPACK FOOTER //
// ./src/pages/booster-options/component.js